/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import { gql } from '@apollo/client';

/**
 * @param {string} brand - baskets or berries
 * @param {string} contentType - type of page, i.e. template_page_customer_service
 */
const findCustomerServiceDetails = () => (
    // very important for serializing. add space between bracket and query name + add typenames to query
    gql`
        query CustomerService($brand: String!, $environment: String!, $contentType: String!) {
            findContent(brand: $brand, environment: $environment, contentType: $contentType)
            {
                content
            }
        }
    `
);

export default findCustomerServiceDetails;
